'use strict'

import { useEffect, useContext, useState } from 'react'
// @material-ui/core components
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'
import Switch from '@mui/material/Switch'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import FormControlLabel from '@mui/material/FormControlLabel'
import Icon from '@mui/material/Icon'
import { Link as MuiLink } from '@mui/material'

// Material Dashboard 2 PRO React components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Footer from 'components/Footer'
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDInput from 'components/MDInput'
import MDTypography from 'components/MDTypography'
import MDSnackbar from 'components/MDSnackbar'
import TimelineList from 'components/Timeline/TimelineList'
import TimelineItem from 'components/Timeline/TimelineItem'

// zerouno
import customerService from 'services/customer.service'
import orderService from 'services/order.service'
import troubleticketService from 'services/troubleticket.service'
import troubleticketanswerService from 'services/troubleticketanswer.service'
import { useForm, Controller } from 'react-hook-form'
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom'
import ZUTitleForm from 'components/ZeroUno/ZUTitleForm'
import ZUAutoComplete from 'components/ZeroUno/ZUAutoComplete'
import utils from 'utils/utils'
import { DateTime } from 'luxon'
import RabbitContext from 'context/rabbit.js'
import { config } from 'variables/Config.js'

export default function TroubleticketForm() {
  const { idObj } = useParams()
  const { idCustomer, idOrder } = useParams()
  const [showSnackbar, setShowSnackbar] = useState({ sh: false, msg: '', color: 'success' })
  const navigate = useNavigate()
  const { rabbit } = useContext(RabbitContext)
  const { register, handleSubmit, formState: { errors }, watch, control, getValues, setValue, reset } = useForm()
  const [customers, setCustomers] = useState([])
  const [customer, setCustomer] = useState([])
  const [orders, setOrders] = useState([])
  const [order, setOrder] = useState({})
  const [obj, setObj] = useState({})
  const [answer, setAnswer] = useState({})
  const [answers, setAnswers] = useState([])
  
  

  const customerIdWatch = watch('customerId')
  const [nf, setNf] = useState(0)

  useEffect(() => {
    fetchCustomers()
    fetchOrders()
  }, [])

  useEffect(() => {
    console.log('nf', nf)
    if(nf >= 2)
      fetchTroubleticket()
  }, [nf])


  const fetchCustomers = () => {
    customerService.getAll(rabbit.companyId, false).then(
      (response) => {
        setCustomers(response.data)
        setNf(nf => nf + 1)
      }
    )
  }

  const fetchOrders = () => {
    if(idCustomer){
     orderService.findByCustomer(idCustomer, false).then(
       (response) => {
         setOrders(response.data)
         
       }
     )
    }
    setNf(nf => nf + 1)
    
 }

  const fetchTroubleticket = () => {
    if (idObj === 'new') {
      if (!idCustomer && !idOrder) {
        const obj = {
          customerId: null,
          customer: {},
          orderId: null,
          order: {},
          data: DateTime.now(),
          oggetto: '',
          descrizione: '',
          file: '',
          chiuso: false,
          companyId: rabbit.companyId
        }  
        console.log(obj)
        setObj(obj)
      }else{
        customerService.get(idCustomer).then(
          (response) => {
            setCustomer(response.data)
            return response.data
          }).then((cust) => {
            orderService.findByCustomer(idCustomer, false).then(
            (response1) => {
              setOrders(response1.data)
              let myOrder = null
              if (idOrder) {
                myOrder = utils.getObjectFromArray(response1.data, idOrder)
                setOrder(myOrder)
              }
              setObj({
                customerId: idCustomer,
                customer: cust,
                orderId: idOrder || null,
                order: myOrder || null,
                data: DateTime.now(),
                oggetto: '',
                descrizione: '',
                file: '',
                chiuso: false,
                companyId: rabbit.companyId
              })
            }).catch((error) => {
              setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
            })
        }).catch((error) => {
          setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
        })
      }
    } else {
      troubleticketService.get(idObj).then(
        (response1) => {
          setObj(response1.data)
          setAnswers(response1.data.answers)
          setAnswer({
            data: DateTime.now(),
            descrizione: '',
            file: '',
          })
          return response1.data
        }).then((data) => {
          if(data.ttusers?.length === 0){
            troubleticketService.markRead(idObj)
          }
        }).catch((error) => {
          setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
        })
    }
  }

  useEffect(() => {  

    reset({ ...obj })
  }, [obj])

  useEffect(() => {
    console.log('customerIdWatch', customerIdWatch)
    if(customerIdWatch){
      orderService.findByCustomer(customerIdWatch, 0).then(
      (response) => {
        return response.data  
      }).then((orders) => 
        orderService.findByCustomer(customerIdWatch, 1).then(
          (response2) => {
            console.log([...orders, ...response2.data])
            setOrders([...orders, ...response2.data])
          })
        )
      }else{
        setOrders([])
      }}, [customerIdWatch])

  const onSubmit = (data) => {
    if (idObj === 'new') {
      data.customerId = data.customerId !== 'n' ? data.customerId : null
      data.orderId = data.orderId !== 'n' ? data.orderId : null
      addObj(data)
    } else {
      let answer = {
       descrizione: data.risposta,
       data: DateTime.now().toJSDate(),
       file: data.file,
       userId: rabbit.userId,
       troubleticketId: idObj,
       chiuso: data.chiuso
      }
      addAnswer(answer)
    }
  }

  const addObj = (data) => {
    troubleticketService.create(data).then(
      (response) => {
        setShowSnackbar({ sh: true, msg: 'operazione effettuata con successo', color: 'success' })
        navigate(`/troubletickets`)
      },
      (error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      }
    )
  }

  const addAnswer = (data) => {
    troubleticketanswerService.create(data).then(
      (response) => {
        setShowSnackbar({ sh: true, msg: 'operazione effettuata con successo', color: 'success' })
        navigate(`/troubletickets`)
      },
      (error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      }
    )
  }

  const renderTimelineItems = () => {
    if (answers && answers.length > 0) {
      return answers.map((item, index) => (
        <TimelineItem
          key={item.id}
          color={item.user.id === rabbit.userId ? 'success' : 'info'}
          icon='label'
          title={`${item.user.name} ${item.user.surname}`}
          dateTime={utils.formatDate(item.data, 'dd/MM/yyyy HH:mm:ss')}
          description={item.descrizione}
          lastItem={index === answers.length - 1}
        />
      ))
    }
    return null
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={6}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Card>
                <ZUTitleForm bgColor='info' title='Ticket' icon='question_answer' />

                <MDBox p={2}>
                  {idObj === 'new' && (
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6}>   
                      {obj.customer && (                    
                        <ZUAutoComplete
                          name='customerId'
                          control={control}
                          required={true}
                          rules={{ required: true }}
                          options={customers}
                          value={obj.customer}
                          getOptionLabel={(item) => item.id ? `${item.surname} ${item.name} [id: ${item.id}]` : ''}
                          label='Cliente'
                          error={!!errors.customerId}
                          
                        />
                        )}
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                      {(obj.customer ||obj.order) && (
                        <ZUAutoComplete
                        name='orderId'
                        control={control}
                        required={false}
                        rules={{ required: false }}
                        options={orders}
                        value={obj.order}
                        getOptionLabel={(item) =>  item.id ? `ordine n. ${item.number} ${item.extension ? ' [ext]' : ''} ${item.substitution ? ' [sost]' : ''} ${item.sale ? ' (vendita)' : ''}` : ''}
                        label='Ordine'
                        error={!!errors.orderId}
                        
                      />)}
                        </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <MDInput
                        fullWidth
                        type='text'
                        required
                        label='oggetto'
                        error={!!(errors.oggetto)}
                        helperText={errors.oggetto}
                        {...register('oggetto', { required: true })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <MDInput
                        fullWidth
                        type='text'
                        required={false}
                        label='descrizione'
                        rows={4}
                        multiline
                        error={!!(errors.descrizione)}
                        {...register('descrizione', { required: false })}
                      />
                    </Grid>
                  </Grid>
                  )}

              {idObj !== 'new' && !obj.chiuso && (
                    <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12}>
                      <MDInput
                        fullWidth
                        type='text'
                        required={true}
                        label='risposta'
                        rows={4}
                        multiline
                        error={!!(errors.risposta)}
                        {...register('risposta', { required: true })}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <Controller
                        control={control}
                        name="chiuso"
                        render={({ field: { value, onChange } }) => (
                          <FormControlLabel
                            control={
                              <Switch
                                checked={value || false}
                                onChange={onChange}
                              />
                            }
                            label="chiuso"
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                  )}


                </MDBox>
                <MDBox p={2}>
                  {!obj.chiuso && (
                    <MDButton type='submit' variant='gradient' color='success' sx={{ ml: 1 }}>
                      Salva
                    </MDButton>
                  )}
                </MDBox>
              </Card>
            </form>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Card>
              <ZUTitleForm
                bgColor='success'
                title='Trouble Ticket'
                icon='access_time'
              />
              {idObj !== 'new' && obj && obj.customer && (
                <>
                  <MDTypography variant='h5' sx={{ mt: 1, mb: 0, ml: 2 }}>
                    Oggetto: {obj.oggetto}
                  </MDTypography>
                  <MDTypography
                    variant='h6'
                    color='info'
                    sx={{ mt: 0, mb: 1, ml: 2 }}
                  >
                    {utils.formatDate(obj.data, 'dd/MM/yyyy HH:mm:ss')}
                  </MDTypography>
                  
                  <MDTypography variant='h6' sx={{ mt: 0, mb: 1, ml: 2 }}>
                    {obj.customer.name + ' ' + obj.customer.surname}
                    {obj.order && (
                      <> - Ordine n. {obj.order.number}</>
                    )}
                  </MDTypography>
                  
                  <MDTypography fontSize='0.8em' sx={{ mt: 0, mb: 1, ml: 2, whiteSpace: 'pre-line', lineHeight: '1.1em' }}>
                    {obj.descrizione}
                  </MDTypography>
                  
                  {obj.file && (
                    <MDButton
                      color='info'
                      variant='outlined'
                      size='small'
                      href={obj.file}
                      target='_blank'
                      sx={{ mt: 0, mb: 1, ml: 4, mr: 4 }}
                    >
                      <Icon>download</Icon>
                      download allegato
                    </MDButton>
                  )}
                </>
              )}
              
              {idObj !== 'new' && answers && answers.length > 0 && (
                <TimelineList title='Cronologia risposte'>
                  {renderTimelineItems()}
                </TimelineList>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      <MDSnackbar
        color={showSnackbar.color}
        icon='notifications'
        title='Notifica'
        content={showSnackbar.msg}
        dateTime='adesso'
        open={showSnackbar.sh}
        autoHideDuration={5000}
        close={() => setShowSnackbar({ sh: false, msg: '', color: 'info' })}
      />
    </DashboardLayout>
  )
}
